import useModal from 'hooks/useModal';
import Confirm from './Confirm.component';
import {
  ConfirmProps,
  OptionalConfirmProps,
  UseConfirmReturn,
} from './helpers';

const useConfirm = (
  generalOptions?: OptionalConfirmProps,
): UseConfirmReturn => {
  const [content, _api] = useModal();

  const api = {
    open: (options: ConfirmProps) => {
      _api.open(
        () => <Confirm onDone={_api.close} {...generalOptions} {...options} />,
        {
          width: 'md',
          color: options.color,
          name: 'action confirmation modal',
          ...options.modalOptions,
        },
      );
    },
    close: _api.close,
  };

  return [content, api];
};

export default useConfirm;
